export type ResendTicketsResult =
  | { status: 'ok' }
  | { status: 'error'; error: 'resend_tickets_repeat_too_soon' | 'resend_tickets_repeat_invalid_email' | string };

export async function resendTickets(email: string): Promise<ResendTicketsResult> {
  const params = new URLSearchParams({ email });

  try {
    const response = await fetch(`/of2/public_services/resend_tickets?${params.toString()}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
    
    const data = await response.json();
    return data as ResendTicketsResult;
  } catch (error) {
    console.error('Error making the request:', error);
    return { status: 'error', error: 'resend_tickets_generic' };
  }
}
